export default __webpack_public_path__ + "static/media/element_spec_35.b1a9077a.webp";